import React from "react";

import s from "./map.module.scss";
import { Node } from "../node";
import { Pipe } from "./pipe";
import { MoreButton } from "./more";

interface Item {
    name: string;
    node: any;
}

export type MapNode = any[] | { [key: string]: any };

export type MapChildExpand = "default" | "expand" | "collapse";

interface Props {
    name: string;
    items: Item[];
    node: MapNode;
}

const ToggleButton: React.FC<{
    expand: boolean;
    setExpand: (expand: boolean) => void;
    children: string;
}> = ({ expand, setExpand, children }) => (
    <button onClick={() => setExpand(!expand)} className={s.toggle}>
        {expand ? "−" : "+"} {children}
    </button>
);

const renderItem = (item: Item, index: number, arr: Item[]) => (
    <li className={s.item} key={item.name}>
        <Pipe last={index === arr.length - 1} />
        <Node name={item.name} node={item.node} />
    </li>
);

// Using object here on purpose so we can expand a previously expanded tree
const FooContext = React.createContext<boolean | null>(null);

export const MapNode: React.FC<Props> = ({ node, name, items }) => {
    const [expand, setExpand] = React.useState(items.length < 4);
    const [foo, setFoo] = React.useState<boolean | null>(null);
    const fooContext = React.useContext(FooContext);

    React.useEffect(() => {
        setFoo(fooContext);
        if (fooContext !== null) setExpand(fooContext);
    }, [fooContext]);

    React.useEffect(() => {
        if (foo !== null) setExpand(foo);
    }, [foo]);

    return (
        <FooContext.Provider value={foo}>
            <div>
                <div className={s.name}>
                    <ToggleButton expand={expand} setExpand={setExpand}>
                        {name}
                    </ToggleButton>
                    <MoreButton node={node} setFoo={setFoo} name={name} />
                </div>
                {expand && <ul> {items.map(renderItem)} </ul>}
            </div>
        </FooContext.Provider>
    );
};
